import { render, staticRenderFns } from "./ed-empty.vue?vue&type=template&id=2ce540e0&scoped=true&"
import script from "./ed-empty.ts?vue&type=script&lang=ts&"
export * from "./ed-empty.ts?vue&type=script&lang=ts&"
import style0 from "./ed-empty.scss?vue&type=style&index=0&id=2ce540e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce540e0",
  null
  
)

export default component.exports